import React, { useState, useEffect } from "react";
import axiosInstance from "../axiosInstance";

const AddTablesStep = ({ onNext }) => {
  const [tableNumbers, setTableNumbers] = useState(""); 

  const handleInputChange = (e) => {
    setTableNumbers(e.target.value);
  };

  const handleSave = async () => {
    // Logic to save table numbers to the database can go here
    //write api which will submit the table numbers to the database using the restuarant id from localhost

    const localStorageData = JSON.parse(localStorage.getItem("user"));
    const restaurantId = localStorageData.restaurantId;
    try {
      await axiosInstance.post("/api/addTables", {
        restaurantId,
        tableNumbers,
      });
      //update the local storage with tables added 
        localStorageData.tablesAdded = true;
        localStorage.setItem("user", JSON.stringify(localStorageData));
      onNext(); // Move to the next step
    } catch (error) {
      console.error("Error saving table numbers:", error);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-lg font-bold mb-4">Add Tables</h2>
      <p className="mb-4">
        Please write the number of tables in your restaurant.
      </p>
      <input
        type="number"
        value={tableNumbers}
        onChange={handleInputChange}
        placeholder="Number of tables in your restaurant"
        className="border rounded p-2 w-full mb-4"
      />
      <button
        onClick={handleSave}
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        Save
      </button>
    </div>
  );
};

export default AddTablesStep;
